<template>
  <teleport to="body">
    <transition name="fade">
      <div
        v-if="isModalOpen"
        class="fixed top-0 left-0 p-15 w-full h-full bg-backdrop flex justify-center items-center z-9999"
        @click.self="close"
      >
        <div class="relative bg-primary max-w-420 w-full rounded-4 pl-20 pt-20 pr-16 pb-12">
          <div class="text-app-color">
            <p class="text-22 font-black">
              {{ type }} limit reached
            </p>
            <p class="text-14 mt-10">
              You have reached the limit for the amount of {{ type.toLowerCase() }} you can have in the free plan.
            </p>
            <p class="text-14 mt-20 mb-25">
              Upgrade to Pro ($4 per month) for an unlimited amount of {{ type.toLowerCase() }}.
            </p>
          </div>
          <div class="flex justify-end items-center">
            <ButtonModule
              text="Cancel"
              :has-hover="true"
              class="text-app-color text-15 mr-12"
              @click="close"
            />
            <ButtonModule
              text="Upgrade"
              class="bg-link-color rounded-4 px-35 py-12 text-white text-15"
              @click="upgrade"
            />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { defineComponent, computed, watch } from 'vue'
import { useStore } from 'vuex'

import { preventBodyScroll } from '@/core/helper-functions'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

export default defineComponent({
  components: { ButtonModule },

  setup () {
    const { state, commit, getters } = useStore()

    const isModalOpen = computed(() => state.plan.showLimitModal)
    const type = computed(() => state.plan.typeLimitModal)
    const isMobile = computed(() => getters.isMobile)

    watch(isModalOpen, value => {
      if (value) commit('toggleSettingsModal', false)
      preventBodyScroll(value)
    })

    function close () {
      commit('toggleLimitModal', { show: false, type: type.value })
    }

    function upgrade () {
      if (isMobile.value) {
        commit('toggleAside', false)
      }
      commit('changeActiveState', 'Plans')
      commit('toggleSettingsModal', true)
      close()
    }

    return {
      // computed
      isModalOpen,
      type,
      // function
      close,
      upgrade
    }
  }
})
</script>
